// Myanmar (my) user-guide copy; HR/legal and native-speaker review is required before release.
export const USER_GUIDE_TRANSLATIONS_MY = {
  'getting-started': {
    title: 'စတင်အသုံးပြုခြင်း',
    summary: 'Portal အတွင်း လမ်းညွှန်ချက်များ၊ ဖုန်းတွင် app အဖြစ် ထည့်သွင်းခြင်းနှင့် သင့်အကောင့်ကို စီမံခြင်း။',
    blocks: [
      {
        text: 'သင်သည် အကောင့်ဝင်ထားပြီးဖြစ်သဖြင့် အခက်ခဲဆုံးအပိုင်း ပြီးပါပြီ။ ပထမဆုံးအကြိမ် အကောင့်ဝင်စဉ် Portal က ကိုယ်ရေးအချက်အလက်ကာကွယ်ရေးမူဝါဒ (PDPA) ကို ဖတ်ရှုလက်ခံရန်နှင့် ကိုယ်ပိုင်စကားဝှက် သတ်မှတ်ရန် လမ်းညွှန်ခဲ့ပါသည်။ ယခုမှစ၍ Portal ကို လွယ်ကူစွာ အသုံးပြုနိုင်ရန် ဤစာမျက်နှာက ကူညီပေးပါမည်။',
      },
      {
        heading: 'Portal အတွင်း လမ်းရှာခြင်း',
        items: [
          'မီနူး (ဘေးဘား) — လုပ်ဆောင်ချက်စာရင်း ဖွင့်ရန် ဖုန်းတွင် ဘယ်ဘက်အပေါ်ရှိ ☰ မီနူးပုံကို နှိပ်ပါ။ ကွန်ပျူတာတွင် မီနူးသည် ဘယ်ဘက်၌ အမြဲဖွင့်ထားပါသည်။',
          'အသိပေးချက်များ — ညာဘက်အပေါ်ရှိ 🔔 ခေါင်းလောင်းတွင် အတည်ပြုချက်များ၊ သတိပေးချက်များနှင့် နောက်ဆုံးအခြေအနေများကို ပြပါသည်။ အနီစက်ရှိလျှင် သင်လုပ်ဆောင်ရန် တစ်ခုခုရှိပါသည်။',
          'သင့်အကောင့် — စကားဝှက်ပြောင်းရန်၊ အခန်းကဏ္ဍပြောင်းရန် (admin/asset အသုံးပြုခွင့်ရှိပါက) သို့မဟုတ် အကောင့်မှထွက်ရန် ညာဘက်အပေါ်ရှိ သင့်အမည်/ပုံကို နှိပ်ပါ။',
          'အမြန်လုပ်ဆောင်ချက်များ — ညာဘက်အောက်ရှိ ဝိုင်းစက်သော ခလုတ်က အသုံးများသည့် လုပ်ဆောင်ချက်များကို တစ်ချက်နှိပ်ရုံဖြင့် ဖွင့်ပေးပါသည်။',
          'ဘာသာစကား — ဤလမ်းညွှန်ကို သင်နှစ်သက်ရာဘာသာဖြင့် ဖတ်ရန် အပေါ်ဘက်ရှိ ဘာသာစကားရွေးချယ်မှုကို သုံးပါ (နောက်ထပ်ဘာသာစကားများ မကြာမီ ရရှိပါမည်)။',
        ],
      },
      {
        heading: 'App ကဲ့သို့ ထည့်သွင်းခြင်း (အကြံပြုပါသည်)',
        items: [
          'Portal ကို ဖုန်းတွင် app (PWA) ကဲ့သို့ အသုံးပြုနိုင်ပြီး app store မလိုပါ။',
          'Android (Chrome) တွင် — မီနူး ⋮ ကိုနှိပ်ပြီး “Add to Home screen” / “Install app” ကို ရွေးပါ။',
          'iPhone (Safari) တွင် — Share ပုံကိုနှိပ်ပြီး “Add to Home Screen” ကို ရွေးပါ။',
          'မျက်နှာပြင်အပြည့်နှင့် ပိုမြန်စွာ အသုံးပြုရန် ဖုန်း၏ Home screen မှ ဖွင့်ပါ။',
        ],
      },
      {
        text: 'စကားဝှက် မေ့နေပါသလား။ Login မျက်နှာပြင်တွင် “Forgot password?” ကိုနှိပ်ပြီး အလုပ်အီးမေးလ် ထည့်ပါ။ စကားဝှက်အသစ် သတ်မှတ်ရန် link ကို အီးမေးလ်ဖြင့် ပို့ပေးပါမည်။',
      },
      {
        text: 'နောက်ဆုံးအချက်အလက်များ ရယူရန် မည်သည့်စာမျက်နှာတွင်မဆို အောက်သို့ဆွဲချပြီး refresh လုပ်နိုင်ပါသည်။',
      },
    ],
  },

  dashboard: {
    title: 'သင့် Dashboard',
    summary: 'သင့်ပင်မမျက်နှာပြင် — အရေးကြီးအချက်များကို အမြန်ကြည့်ပြီး အသုံးများသည့် လုပ်ဆောင်ချက်များကို တစ်ချက်နှိပ်၍ ဖွင့်နိုင်သည်။',
    routeLabel: 'Dashboard သို့ သွားရန်',
    blocks: [
      {
        text: 'Dashboard သည် အကောင့်ဝင်သည့်အခါ ဖွင့်လာသော ပင်မမျက်နှာပြင်ဖြစ်သည်။ ဘယ်ဘက်အပေါ်ရှိ ကုမ္ပဏီ logo ကိုနှိပ်၍ အချိန်မရွေး ပြန်လာနိုင်သည်။ အကျဉ်းချုပ်နှင့် အမြန်လမ်းကြောင်းများကို ပြသပြီး မြင်ရသည့် card များသည် သင့်အခန်းကဏ္ဍအလိုက် ကွာခြားပါသည်။',
      },
      {
        heading: 'လူတိုင်း မြင်ရမည့်အရာများ',
        items: [
          'အပေါ်ဘက်တွင် သင့်အမည်ပါသော နှုတ်ခွန်းဆက်စာ။',
          'Recent Leave Applications — သင်နောက်ဆုံးတင်ထားသော ခွင့်တောင်းခံမှုများနှင့် အခြေအနေ (Pending, Approved စသည်)။ အသေးစိတ်ကြည့်ရန် မျက်လုံးပုံကိုနှိပ်ပါ၊ သို့မဟုတ် Leave Management ဖွင့်ရန် “View all” ကိုနှိပ်ပါ။',
          'Leave Balances — ခွင့်အမျိုးအစားတစ်ခုစီအတွက် ရရှိနိုင်သည့်ရက်၊ သုံးပြီးသည့်ရက်နှင့် ခံစားခွင့်ရက်ကို ပြသော card များ။ စာရင်းအပြည့်ကြည့်ရန် “View all” ကိုနှိပ်ပါ။',
        ],
      },
      {
        text: 'Quick Actions — မည်သည့်မျက်နှာပြင်တွင်မဆို ညာဘက်အောက်ရှိ ဝိုင်းစက်သောခလုတ်ကို နှိပ်၍ Clock In/Out၊ ခွင့်တင်ခြင်းနှင့် Petty Cash Claim တင်ခြင်းတို့ကို အမြန်လုပ်နိုင်သည်။ Staff နှင့် Director များတွင် digital name card မျှဝေရန် “My Name Card” လည်း ရှိပါသည်။',
      },
      {
        text: 'My Approvals — သင့်ဆုံးဖြတ်ချက်ကို စောင့်နေသော ခွင့်တောင်းခံမှုများကို ဤ card တွင် ပြပြီး Dashboard ပေါ်တွင် အရေအတွက် badge ပြပါသည်။ အတည်ပြု/ငြင်းပယ်နည်းကို “Reporting Officer များအတွက် — ခွင့်အတည်ပြုခြင်း” တွင် ကြည့်ပါ။',
      },
      {
        heading: 'အဖွဲ့ သတိပေးချက်များ (Reporting Officer နှင့် HOD များ)',
        items: [
          'Team Alerts သည် သင့်အဖွဲ့၏ attendance ခြွင်းချက်များကို သတိပေးသည်။ ဥပမာ worker တစ်ဦး Clock In လုပ်ထားပြီး Clock Out မရှိခြင်း။',
          'သတိပေးချက်ကိုနှိပ်၍ စစ်ဆေးပြီး ဖြေရှင်းပါ (ဥပမာ worker ကိုယ်စား Clock Out အချိန် အတည်ပြုခြင်း)။',
        ],
      },
      {
        text: 'Nightwork နှင့် Worker Trade Transfer card များသည် သင့်နှင့်သက်ဆိုင်သည့်အခါ ဤနေရာတွင် ပေါ်လာပါသည်။ ဥပမာ လက်ရှိ nightwork assignment၊ recovery day (နားရက်) သို့မဟုတ် သင်အသိအမှတ်ပြုရန် စောင့်နေသော trade-transfer ရှိသည့်အခါ ဖြစ်သည်။ ဖွင့်ရန် card ပေါ်ရှိ “View All” ကိုနှိပ်ပါ။ (အသေးစိတ်ကို Nightwork နှင့် Worker Trade Transfer အပိုင်းများတွင် ကြည့်ပါ။)',
      },
    ],
  },

  attendance: {
    title: 'အလုပ်ဝင်ချိန်နှင့် အလုပ်ဆင်းချိန် မှတ်တမ်းတင်ခြင်း',
    summary: 'နေ့စဉ် အလုပ်ချိန်နှင့် လုပ်ငန်းခွင်နေရာကို မှတ်တမ်းတင်ပါ။',
    routeLabel: 'Attendance ဖွင့်ရန်',
    blocks: [
      {
        text: 'ဘေးဘားမှ “Attendance — Clock In/Out & Time Tracking” ကို ဖွင့်ပါ။ စာမျက်နှာတွင် စင်ကာပူအချိန် live clock နှင့် ယနေ့ သင့်လုပ်ဆောင်ချက်များကို ပြပါသည်။',
      },
      {
        heading: 'Clock In လုပ်နည်း',
        items: [
          'အစိမ်းရောင် “Clock In” ခလုတ်ကို နှိပ်ပါ။',
          'ဖုန်းက တည်နေရာအသုံးပြုခွင့် တောင်းသည့်အခါ ခွင့်ပြုပါ။ သင့် site ကို GPS ဖြင့် အတည်ပြုပါသည်။',
          '“Select Location” pop-up တွင် သင့် project ကိုရွေးပါ။ ၃၀၀ မီတာခန့်အတွင်းရှိ project များကို “Nearby” tab တွင် တွေ့နိုင်သည်။ မတွေ့ပါက “All Projects” သို့မဟုတ် search box ကို သုံးပါ။',
          'Project တွင် work site တစ်ခုထက်ပိုပါက “Select Work Site” pop-up တွင် သင့် site ကိုရွေးပါ။ Site တစ်ခုတည်းသာရှိပါက အလိုအလျောက် ရွေးပေးပါမည်။',
          'Clock In ပြီးပါပြီ။ ခလုတ်သည် အနီရောင် “Clock Out” ဖြစ်သွားပြီး စတင်ချိန်နှင့် “Active since” ကို မြင်ရပါမည်။',
        ],
      },
      {
        heading: 'Clock Out လုပ်နည်း',
        items: [
          'အနီရောင် “Clock Out” ခလုတ်ကို နှိပ်ပါ။ လက်ရှိ GPS တည်နေရာကို အလိုအလျောက် ယူပါမည်။',
          'တောင်းဆိုပါက ယနေ့လုပ်ခဲ့သည့်အလုပ်ကို အနည်းဆုံး စာလုံး ၁၀ လုံးဖြင့် Work Description အတိုချုံးရေးပြီး “Submit & Clock Out” ကိုနှိပ်ပါ။',
          'Worker များကို အချိန်ပိုအကြောင်း မေးနိုင်သည်။ “Yes”/“No” ဖြေပြီး အလုပ်ပြီးချိန်ကိုရွေးကာ အတည်ပြုပါ။ ဤမှတ်တမ်းဖြင့် OT တောင်းခံနိုင်ပါသည်။',
          '“Clocked out successfully” ဟု မြင်ရပါမည်။',
        ],
      },
      {
        heading: 'သင့်လုပ်ဆောင်ချက်နှင့် အကျဉ်းချုပ်',
        items: [
          'Activity စာရင်း — Clock In/Clock Out တစ်ကြိမ်စီ၏ ကြာချိန်၊ work site၊ project code နှင့် သင်ထည့်ထားသည့် မှတ်ချက်များ။',
          'ကာလပြောင်းရန် — funnel ပုံကိုနှိပ်၍ Today, This Week, This Month နှင့် Last Month တို့အကြား ပြောင်းနိုင်သည်။ Activity စာရင်းနှင့် Summary နှစ်ခုလုံး အတူပြောင်းပါမည်။',
          'Summary panel — ရွေးထားသောကာလအတွင်း အလုပ်လုပ်သည့်ရက်နှင့် နာရီကို ပြသည် (သတ်မှတ်ထားသော နေ့လယ်စာ/ညစာနားချိန်များကို အလုပ်ချိန်မှ နုတ်ထားပါသည်)။',
          'ယနေ့ Nightwork shift သို့မဟုတ် Recovery day (အလုပ်လုပ်ရန်မလိုသောနေ့) ဖြစ်ပါက banner ဖြင့် အသိပေးပါမည်။',
        ],
      },
      {
        text: 'သင့်အချိန်ပိုကိုလည်း ဤနေရာတွင် မြင်ရပါမည်။ MOM ၏ လစဉ် ၇၂ နာရီ ကန့်သတ်ချက်ထဲသို့ ရေတွက်သည့် နာရီကို လက်ရှိလအတွင်း “Live” သို့မဟုတ် “Finalized” အဖြစ် ပြပြီး Summary အောက်တွင် လစဉ် overtime ပြက္ခဒိန်လည်း ရှိပါသည်။',
      },
      {
        text: 'Clock In လုပ်ရန် တည်နေရာလိုအပ်ပါသည်။ “Location permission denied” ဟု ပေါ်ပါက browser/ဖုန်း setting တွင် Portal အတွက် တည်နေရာအသုံးပြုခွင့် ဖွင့်ပြီး ထပ်စမ်းပါ။',
      },
    ],
  },

  'leave-apply': {
    title: 'ခွင့်တင်ခြင်း',
    summary: 'ခွင့်တင်ပါ၊ စာရွက်စာတမ်းများ ပူးတွဲပါ၊ အတည်ပြုမှုအခြေအနေကို စောင့်ကြည့်ပါ။',
    routeLabel: 'Leave ဖွင့်ရန်',
    blocks: [
      {
        heading: 'ခွင့်တင်ရန်',
        items: [
          'ဘေးဘားမှ “Leave Management” ကို ဖွင့်ပါ။',
          'အပေါ်ရှိ “Apply for Leave” ကိုနှိပ်ပါ၊ သို့မဟုတ် သက်ဆိုင်ရာ balance card ပေါ်ရှိ “Apply” ကိုနှိပ်ပါ။',
          'စာရင်းမှ ခွင့်အမျိုးအစား ရွေးပါ (သင်ခံစားခွင့်ရှိသည့် အမျိုးအစားများသာ ပေါ်ပါမည်)။',
          'စတင်ရက်နှင့် ပြီးဆုံးရက် ရွေးပါ။ နေ့တစ်ဝက်အတွက် ရက်စွဲပေါ်ရှိ AM/PM toggle ကို သုံးပါ။',
          'ထိုခွင့်အမျိုးအစားအတွက် လိုအပ်ချက်များ (ဥပမာ အကြောင်းပြချက်) ဖြည့်ပြီး “Submit Application” ကိုနှိပ်ပါ။',
          '“Leave application submitted successfully!” ဟု ပေါ်ပြီး တောင်းခံမှုသည် သင့်စာရင်းတွင် Pending အဖြစ် ပေါ်လာပါမည်။',
        ],
      },
      {
        heading: 'အချို့ခွင့်များအတွက် လိုအပ်သော စာရွက်စာတမ်းများ',
        items: [
          'Marriage Leave — Profile → Documents → Family Documents တွင် လက်ထပ်စာချုပ်တင်ပြီး HR က စစ်ဆေးအတည်ပြုပြီးမှ ရွေးနိုင်ပါသည်။ ကြိုတင်တင်ထားပါ။',
          'Maternity / Paternity Leave — ကလေးမွေးစာရင်းကို Profile → Documents → Family Documents တွင်တင်ပြီး HR အတည်ပြုပြီးမှ ရွေးနိုင်သည်။ Paternity Leave အတွက် လက်ထပ်စာချုပ်လည်း လိုပါသည်။',
          'Sick / Hospitalisation Leave — ခွင့်တင်စဉ် Medical Certificate (ဓာတ်ပုံ သို့မဟုတ် PDF) တင်ပါ။ System က အလိုအလျောက် ဖတ်သောကြောင့် ပုံကို ကြည်လင်အောင် ရိုက်ပါ။',
          'Compassionate Leave — သေစာရင်းတင်ပါ (ရက် ၃၀ အတွင်း တင်နိုင်ပြီး HR က စစ်ဆေးပါမည်)။',
          'Home Leave / Urgent Leave (worker များ) — အတည်ပြုပြီးနောက် HR စစ်ဆေးနိုင်ရန် လေယာဉ်လက်မှတ် တင်ပါ။',
        ],
      },
      {
        text: 'Marriage, Maternity နှင့် Paternity Leave များသည် စာရွက်စာတမ်းဖြင့် ဖွင့်ရသောခွင့်များဖြစ်သည်။ သက်ဆိုင်ရာ certificate ကို Profile တွင်တင်ပြီး HR အတည်မပြုမချင်း ခွင့်အမျိုးအစားစာရင်းတွင် မပေါ်ပါ။ လိုအပ်သည့်အချိန်တွင် အသင့်ဖြစ်စေရန် ကြိုတင်တင်ထားပါ။',
      },
      {
        heading: 'သင့်ခွင့်လက်ကျန်ကို နားလည်ထားပါ',
        items: [
          '“Leave Balances” card များတွင် ခွင့်အမျိုးအစားတိုင်း၏ ရရှိနိုင်သည့်ရက်၊ သုံးပြီးသည့်ရက်နှင့် စုစုပေါင်းခံစားခွင့်ကို ပြပါသည်။',
          'Annual Leave အတွက် အနည်းဆုံး အလုပ်သက် ၃ လလိုပါသည်။ ထိုမတိုင်မီ သို့မဟုတ် လက်ကျန်ကုန်လျှင် Unpaid Leave အဖြစ် တင်မည်ဖြစ်ပြီး စာမျက်နှာက အသိပေးပါမည်။',
          'Annual Leave တင်သည့်အခါ Off in Lieu (OIL) ကို သက်တမ်းကုန်ရန် အနီးဆုံးမှစ၍ အလိုအလျောက် သုံးပါသည်။ OIL credit တစ်ခုစီ၏ သက်တမ်းကုန်ရက်ကို card တွင်ပြသည်။ သက်တမ်းမကုန်မီ သုံးပါ၊ ကုန်သွားသော OIL ကို ပြန်တောင်း၍မရပါ။',
          'Marriage သို့မဟုတ် Compassionate Leave ကဲ့သို့ အချို့ခွင့်များသည် သင်အရည်အချင်းပြည့်သည့်အခါ သို့မဟုတ် ပထမဆုံးအသုံးပြုသည့်အခါမှသာ ပေါ်နိုင်ပါသည်။',
        ],
      },
      {
        text: 'Annual Leave တိုးလာပုံ — Annual Leave ကို ဇန်နဝါရီ ၁ ရက်တွင် တစ်နှစ်စာလုံး တစ်ခါတည်း မပေးဘဲ အလုပ်လုပ်သည့်အလျောက် ရရှိပါသည်။ အလုပ်သက် တစ်လပြည့်တိုင်း နှစ်စဉ်ခံစားခွင့်၏ အစိတ်အပိုင်းကို လစဉ်အလုပ်စဝင်ရက် (“monthsary”) ဝန်းကျင်တွင် ထည့်ပေးသဖြင့် လက်ကျန်သည် လတိုင်း တိုးလာပါသည်။ အလုပ်သက်တစ်နှစ်ပြည့်ပြီးနောက် တစ်နှစ်စာခံစားခွင့် အပြည့်အတိုင်းဖြစ်လာပြီး အလုပ်သက်တိုးသလို နောက်ထပ်ရက်များ ရရှိပါမည်။ ထို့ကြောင့် အစောပိုင်းလက်ကျန်သည် ဖော်ပြထားသော နှစ်စဉ်ရက်ထက် နည်းနေနိုင်သော်လည်း လပြည့်တိုင်း ဆက်တိုးပါမည်။',
      },
      {
        text: 'Annual Leave ကို အလိုအလျောက် ဖြည့်သုံးပုံ — Annual Leave တင်သည့်အခါ system က သတ်မှတ်အစီအစဉ်အတိုင်း သုံးပါသည်။ ပထမ သင်ရထားသော Off in Lieu (OIL) ထဲမှ သက်တမ်းကုန်ရန် အနီးဆုံးကို သုံးပြီး၊ ထို့နောက် Annual Leave လက်ကျန်ကို သုံးပါသည်။ နှစ်မျိုးလုံးကုန်မှ ကျန်ရက်ကို Unpaid Leave ဖြစ်စေပါသည်။ မတင်မီ form တွင် “2 OIL + 2 AL + 1 UL” ကဲ့သို့ ခွဲပြသဖြင့် လစာမဲ့ရက် မည်မျှရှိမည်ကို အမြဲသိနိုင်ပါသည်။',
      },
      {
        heading: 'သီးခြားခွင့်အမျိုးအစားများကို ဘယ်အချိန်သုံးရမည်',
        items: [
          'External Activity — ကုမ္ပဏီအလုပ်ကြောင့် project နေရာတွင် Clock In/Out မလုပ်နိုင်သော အခြားနေရာသို့ သွားရသည့်အခါသာ သုံးပါ။ ဥပမာ seminar၊ conference သို့မဟုတ် ကုမ္ပဏီခရီး။ Project/site တွင် အလုပ်လုပ်ပါက ပုံမှန်အတိုင်း ထိုနေရာတွင် Clock In/Out လုပ်ပါ။ Activity အမျိုးအစားရွေးပြီး နေရာနှင့် လုပ်ငန်းအကြောင်းပြချက်အတိုချုံး ထည့်ပါ။',
          'On Course — ကုမ္ပဏီက ခွင့်ပြုထားသော သင်တန်း/course တက်သည့်အခါ တင်ပါ။ Course/training အမည်နှင့် နေရာ ထည့်ပါ။',
          'Claim: Off in Lieu — ခွင့်ပြုထားသော နားရက်၊ တနင်္ဂနွေ သို့မဟုတ် public holiday အလုပ်အတွက် OIL တောင်းခံပါ။ အလုပ်လုပ်သည့်ရက်မှ ရက် ၃၀ အတွင်း တင်ရပြီး ယနေ့အတွက် မတင်နိုင်ပါ။ OT ခံစားခွင့်ရှိသော workman (worker) များသည် ပုံမှန်အလုပ်ရက် အလုပ်ချိန်ပြင်ပအတွက် OT ငွေရသောကြောင့် OIL ကို ထပ်မတောင်းနိုင်ပါ။ Weekday after-hours OIL သည် OT မရသော staff အတွက်သာ ဖြစ်သည်။',
        ],
      },
      {
        heading: 'မိသားစုဆိုင်ရာခွင့် — Maternity, Paternity, Shared Parental နှင့် Childcare',
        items: [
          'Maternity / Paternity Leave ကို Shared Parental Leave (SPL) မတိုင်မီ အရင်သုံးရပါသည်။ မိခင်အတွက် Maternity Leave၊ ဖခင်အတွက် Paternity Leave စသည့် မိမိ statutory parental leave အားလုံးသုံးပြီးမှ SPL ကို ဖွင့်ပေးပြီး စာရင်းတွင် ပေါ်ပါမည်။ မပြီးမီ SPL တင်ပါက system က ပိတ်ပြီး မည်သည့်ခွင့်ကို အရင်သုံးရမည်ကို ပြောပါမည်။',
          'ဤ parental leave များသည် calendar year မဟုတ်ဘဲ ကလေးမွေးရက်နှင့် ချိတ်ဆက်ထားပြီး မွေးပြီး ၁၂ လအတွင်း သက်တမ်းကုန်သည့်အထိ အသုံးပြုနိုင်သည်။ ထို့ကြောင့် လက်ကျန်သည် သက်တမ်းကုန်ရက်အထိ နောက်နှစ်သို့ ဆက်သယ်နိုင်ပါသည်။',
          'Childcare Leave (CCL) သည် calendar year တစ်နှစ်ချင်းစီအတွက် ခံစားခွင့်ဖြစ်ပြီး ဇန်နဝါရီ ၁ ရက်တိုင်း အသစ်ပြန်စပါသည်။ မသုံးရသေးသော CCL ကို နောက်နှစ်သို့ မသယ်နိုင်သဖြင့် သက်ဆိုင်ရာနှစ်အတွင်း သုံးရန် စီစဉ်ပါ။',
        ],
      },
      {
        text: 'Home Leave နှင့် Annual Leave — စင်ကာပူမှထွက်၍ မိခင်နိုင်ငံသို့ ပြန်သည့်အခါ Home Leave သုံးပါ။ စင်ကာပူတွင်ပင် နေပြီး အနားယူသည့်အခါ Annual Leave သုံးပါ။ သင့်ခရီးအစီအစဉ်နှင့် ကိုက်ညီသည်ကို ရွေးပါ။',
      },
      {
        text: 'Home Leave ခရီးတစ်ကြိမ်ကို calendar day အများဆုံး ၃၀ ရက် (သို့မဟုတ် ယခုနှစ်အတွက် ကျန်ရှိသောရက်) အထိ ယူနိုင်ပါသည်။ စတင်ရက်ရွေးပြီးနောက် form က နောက်ဆုံးပြန်လာနိုင်သည့်ရက်ကို ပြပါမည်။ စတင်ရက်နှင့် ပြန်လာရက် နှစ်ရက်လုံးကို ရေတွက်ပါသည်။ ဥပမာ 24 Oct မှ 24 Nov သည် ၃၂ ရက်ဖြစ်သောကြောင့် 24 Oct မှ စတင်လျှင် နောက်ဆုံးပြန်လာရက်မှာ 22 Nov ဖြစ်သည်။',
      },
      {
        heading: 'အခြေအနေကြည့်ခြင်း၊ ပြင်ခြင်း သို့မဟုတ် ပယ်ဖျက်ခြင်း',
        items: [
          'Application တစ်ခုစီတွင် Pending, Approved, Auto Approved, Rejected သို့မဟုတ် Cancelled အခြေအနေ ပြပါသည်။',
          '“View Details” ကြည့်ရန် မျက်လုံးပုံကိုနှိပ်ပြီး အတည်ပြုမှုတိုးတက်ပုံနှင့် နောက်တစ်ဆင့် မည်သူအတည်ပြုရမည်ကို ကြည့်ပါ။',
          'Draft ကို Edit လုပ်နိုင်သည်၊ အနာဂတ်ရက်၏ Pending request ကို Delete လုပ်နိုင်သည်၊ သို့မဟုတ် Approved request ကို Cancel လုပ်နိုင်သည် (ခွင့်လက်ကျန် ပြန်ထည့်ပေးပါမည်)။ Cancel လုပ်ရာတွင် အကြောင်းပြချက် လိုပါသည်။',
        ],
      },
      {
        text: 'စောစောတင်ပါ။ အချို့ခွင့်များ ကြိုတင်အသိပေးရပြီး Home Leave အတွက် ရက် ၃၀ လိုပါသည်။ Urgent Leave တွင် ကြိုတင်အသိပေးရန် မလိုပါ (မစောင့်နိုင်သောကိစ္စအတွက် သုံးပါ)။ နောက်ကျနေပါက form က သတိပေးပါမည်။',
      },
    ],
  },

  'leave-extension': {
    title: 'Home Leave သို့မဟုတ် Urgent Leave ရက်တိုးခြင်း',
    summary: 'ပြည်ပရောက်နေပြီး အချိန်ပိုလိုပါသလား။ အတည်ပြုပြီးသော Home/Urgent Leave တွင် ရက်ထပ်တိုးပါ။',
    routeLabel: 'Leave ဖွင့်ရန်',
    blocks: [
      {
        text: 'အတည်ပြုပြီးသော Home Leave သို့မဟုတ် Urgent Leave ယူနေစဉ် ပြန်မလာမီ ရက်အနည်းငယ် ပိုလိုပါက Portal ထဲမှ ရက်တိုးတောင်းနိုင်ပြီး application အသစ်တင်ရန် မလိုပါ။ Home Leave နှင့် Urgent Leave သာ ရက်တိုးနိုင်ပါသည်။',
      },
      {
        heading: 'ရက်တိုး တောင်းခံရန်',
        items: [
          '“Leave Management” ဖွင့်ပြီး အတည်ပြုထားသော Home Leave သို့မဟုတ် Urgent Leave ပေါ်ရှိ မျက်လုံးပုံကိုနှိပ်၍ အသေးစိတ်ကြည့်ပါ။',
          'အောက်ဘက်ရှိ “Home Leave / Urgent Leave Extension” အပိုင်းသို့ ဆင်းပြီး “Request Extension” ကိုနှိပ်ပါ။ ဤခလုတ်သည် ခွင့်ယူနေဆဲအချိန်တွင်သာ ပေါ်ပါသည်။',
          'New Return Date ရွေးပါ။ ထပ်တိုးရက်များသည် လက်ရှိပြီးဆုံးရက် နောက်တစ်နေ့မှ သင်ရွေးသော ပြန်လာရက်အထိ ဖြစ်သည်။',
          'Reason for Extension အတိုချုံး ရေးပါ (မဖြစ်မနေလိုသည်)၊ ပြီးနောက် submit လုပ်ပါ။',
          '“Extension request submitted. Awaiting approval.” ဟု ပေါ်ပါမည်။ မူလခွင့်ကို ကိုင်တွယ်ခဲ့သော approver များထံ ပို့ပါမည်။',
        ],
      },
      {
        heading: 'ဘယ်အချိန် တောင်းနိုင်သလဲ',
        items: [
          'ခွင့်ကို အပြည့်အဝ အတည်ပြုပြီးသား ဖြစ်ရမည်။ Pending သို့မဟုတ် Rejected application ကို ရက်မတိုးနိုင်ပါ။',
          'ခွင့်ယူနေစဉ်သာ တောင်းနိုင်သည်။ စတင်ရက်မှ လက်ရှိပြီးဆုံးရက်အထိ ဖြစ်ရမည်။ မစတင်မီ သို့မဟုတ် ပြီးသွားပြီးနောက် မတောင်းနိုင်ပါ။',
          'ယခင် extension ပေါ်တွင် မတောင်းဘဲ မူလ application ပေါ်တွင် အမြဲတောင်းပါ။',
          'တစ်ကြိမ်တွင် extension တစ်ခုသာ Pending ဖြစ်နိုင်သည်။ Approved သို့မဟုတ် Rejected ဖြစ်သည်အထိ စောင့်ပြီးမှ နောက်တစ်ခုတောင်းပါ။',
        ],
      },
      {
        text: 'Home Leave နှင့် Urgent Leave နှစ်မျိုးပေါင်း ကန့်သတ်ချက်သည် တစ်နှစ်လျှင် calendar ရက် ၆၀ ဖြစ်ပြီး ဇန်နဝါရီ ၁ ရက်တိုင်း ပြန်စပါသည်။ Form တွင် ကျန်ရက်နှင့် ရွေးနိုင်သည့် နောက်ဆုံးပြန်လာရက်ကို ပြပါသည်။ ကန့်သတ်ချက်ကျော်သည့် တောင်းခံမှုကို ပိတ်ပါမည်။',
      },
      {
        heading: 'အတည်ပြုပြီးနောက် — လေယာဉ်လက်မှတ်အသစ် တင်ပါ',
        items: [
          'အတည်ပြုပြီးလျှင် extension card တွင် “Upload Ticket” ပေါ်ပါမည်။ Card ကိုနှိပ်၍ ဖွင့်ပါ။',
          'HR က ခရီးစဉ်စစ်ဆေးနိုင်ရန် ပြန်လာမည့် လေယာဉ်လက်မှတ်အသစ် တင်ပါ။',
          'HR စစ်ဆေးနေစဉ် card သည် “HR Reviewing” ဖြစ်ပြီး လက်မှတ်လက်ခံပြီးလျှင် “Activated” ဖြစ်ပါမည်။',
        ],
      },
      {
        heading: 'သင့် extension များကို စောင့်ကြည့်ခြင်း',
        items: [
          'Extension တစ်ခုစီကို extension အပိုင်းအောက်တွင် card သီးသန့်အဖြစ် ပြပြီး ရက်စွဲအသစ်များနှင့် အခြေအနေကို ပြပါသည်။',
          'အခြေအနေများ — “Awaiting Approval” → “Upload Ticket” (အတည်ပြုပြီး၊ လက်မှတ်လို) → “HR Reviewing” (လက်မှတ်တင်ပြီး) → “Activated” (လက်မှတ်လက်ခံပြီး)။ “Rejected” သို့မဟုတ် “Ticket Rejected” ဆိုလျှင် သင်လုပ်ဆောင်ရန် လိုပါသည်။',
          'မူလခွင့်နှင့် ခွဲသိနိုင်ရန် ခွင့်စာရင်းရှိ ဤတောင်းခံမှုများဘေးတွင် “Extension” badge ပေါ်ပါသည်။',
        ],
      },
    ],
  },

  'leave-calendar': {
    title: 'ခွင့်ပြက္ခဒိန်',
    summary: 'သင့်ဌာန သို့မဟုတ် ကုမ္ပဏီတစ်ခုလုံးတွင် မည်သူခွင့်ယူထားသည်ကို ကြည့်ပါ။',
    routeLabel: 'Leave Calendar ဖွင့်ရန်',
    blocks: [
      {
        heading: 'ခွင့်အစီအစဉ်များ ကြည့်ရန်',
        items: [
          'ဘေးဘားမှ “Leave Calendar” ကို ဖွင့်ပါ။',
          'အပေါ်ရှိ toggle ဖြင့် “Department” view နှင့် “Company” view ကို ပြောင်းပါ။',
          'လများပြောင်းရန် လမြှားများကို သုံးပါ။ လက်ရှိလသို့ ပြန်ရန် “Today” ကိုနှိပ်ပါ။',
          'ရက်တစ်ရက်ကိုနှိပ်၍ ထိုနေ့ခွင့်ယူသူများကို ဌာနအလိုက် အုပ်စုခွဲကြည့်ပါ။',
        ],
      },
      {
        heading: 'ရှာဖွေခြင်းနှင့် စစ်ထုတ်ခြင်း',
        items: [
          'အမည် သို့မဟုတ် Staff ID ဖြင့် လူရှာရန် search box ကို သုံးပါ။',
          'သီးခြားလုပ်ဖော်ကိုင်ဖက်များ ရွေးရန် filter (funnel) ခလုတ်ကို သုံးပါ။ ရွေးထားမှုကို နောက်တစ်ကြိမ်အတွက် မှတ်ထားပါမည်။',
          'Approved ခွင့်များသာ ပြက္ခဒိန်တွင် ပေါ်ပါသည်။ Public holiday များကို အရောင်ခြယ်၍ label တပ်ထားပါသည်။',
        ],
      },
      {
        text: 'ကိုယ်ရေးအချက်အလက် ကာကွယ်ရန် ခွင့်အကြောင်းရင်းအတိအကျအစား “Out of Office”, “Unavailable” ကဲ့သို့ အထွေထွေ label များဖြင့် ပြပါသည်။ အောက်ဘက်ရှိ legend တွင် အရောင်များ၏ အဓိပ္ပာယ်ကို ရှင်းပြထားပါသည်။',
      },
    ],
  },

  profile: {
    title: 'ကျွန်ုပ်၏ Profile',
    summary: 'ဆက်သွယ်ရန်အချက်အလက်၊ အရေးပေါ်ဆက်သွယ်ရန်သူနှင့် စာရွက်စာတမ်းများကို အမြဲနောက်ဆုံးအခြေအနေထားပါ။',
    routeLabel: 'My Profile ဖွင့်ရန်',
    blocks: [
      {
        heading: 'သင့် Profile တွင် ရှိသောအရာများ',
        items: [
          'အပေါ်ဘက် tab များ — Personal, Employment, Compensation, Professional, Legal & Compliance နှင့် Documents (သက်ဆိုင်ပါက Name Card / Skills Upgrading လည်း ပါမည်)။',
          'ဖုန်း၊ NRIC၊ လစာ၊ ဘဏ်ကဲ့သို့ လျှို့ဝှက်အချက်အလက်များကို ပြရန်/ဖျောက်ရန် ဘေးရှိ မျက်လုံးပုံကို နှိပ်ပါ။',
        ],
      },
      {
        heading: 'ဆက်သွယ်ရန်အချက်အလက် ပြင်ရန်',
        items: [
          '“Personal” tab တွင် “Edit Profile” ကိုနှိပ်ပါ။',
          'ကိုယ်ပိုင်ဖုန်း၊ ကိုယ်ပိုင်အီးမေးလ်၊ နေရပ်လိပ်စာနှင့် unit/postal code ကို ပြင်နိုင်ပါသည်။',
          'လိပ်စာပြင်သည့်အခါ postal code ထည့်ပြီး အလိုအလျောက်ဖြည့်ရန် “Find Address” ကိုနှိပ်ပါ။',
          'သိမ်းရန် “Save Changes”၊ မသိမ်းဘဲထွက်ရန် “Cancel” ကိုနှိပ်ပါ။',
        ],
      },
      {
        heading: 'အရေးပေါ် ဆက်သွယ်ရန်သူ ထည့်ရန်',
        items: [
          '“Personal” tab ရှိ “Emergency Contacts” ကိုရှာပြီး “Add Contact” ကိုနှိပ်ပါ။',
          'အမည်အပြည့်အစုံ၊ တော်စပ်ပုံနှင့် အနည်းဆုံး ဖုန်းနံပါတ်တစ်ခု ထည့်ပါ (နိုင်ငံတကာပုံစံ၊ ဥပမာ +65 9000 0000)။',
          'သိမ်းရန် “Add Contact” ကိုနှိပ်ပါ။ အချိန်မရွေး ပြင်နိုင်၊ ဖျက်နိုင်ပါသည်။',
        ],
      },
      {
        heading: 'စာရွက်စာတမ်းတင်ရန် (Documents tab)',
        items: [
          '“Documents” tab ကိုဖွင့်ပြီး “Document Uploads” sub-tab ကို ဖွင့်ပါ။',
          'ကိုက်ညီသည့် category ကိုရှာ၍ file ကို drop zone ပေါ် ဆွဲတင်ပါ၊ သို့မဟုတ် ဖုန်း/ကွန်ပျူတာမှ ရွေးရန် “browse” ကိုနှိပ်ပါ။',
          'File သည် PDF သို့မဟုတ် image (JPG/PNG) ဖြစ်နိုင်ပြီး တစ်ခုလျှင် 5MB အထိ ဖြစ်ရမည်။ ID card များအတွက် ကြည်လင်သော နမူနာပုံကြည့်ရန် “Sample” ကိုနှိပ်ပါ။',
          'System က file ကို OCR ဖြင့် scan လုပ်ပါက ဖတ်ပြီးသည်အထိ စာမျက်နှာမှ မထွက်ဘဲ စောင့်ပါ။ Verification pop-up တွင် ထုတ်ယူထားသောအချက်အလက်ကို စစ်ပြီး HR စစ်ဆေးရန် submit လုပ်ပါ။',
          'Upload တစ်ခုစီတွင် Processing, Pending HR / Pending Review, Verified သို့မဟုတ် Rejected အခြေအနေ ပြပါသည်။',
        ],
      },
      {
        heading: 'မည်သည့် drop zone ကို သုံးရမည်',
        items: [
          'Identity Documents — ID Card (Front), ID Card (Back), Passport, Driving Licence။',
          'Banking Documents — ဘဏ် statement/letter။ သင့်ဘဏ်အကောင့်ကို ဤနည်းဖြင့် ပြင်ပေးပြီး တိုက်ရိုက်စာရိုက်ထည့်၍ မရပါ။',
          'Education Certificates & Professional Certificates — ပညာရေးနှင့် ကျွမ်းကျင်မှု certificate များ (သင့် Professional tab တွင် record ထည့်ပေးပါမည်)။',
          'Family Documents — မွေးစာရင်း၊ လက်ထပ်စာချုပ်နှင့် Compassionate Leave အတွက် သေစာရင်း။ ဤစာရွက်စာတမ်းများတင်ခြင်းဖြင့် Childcare, Maternity, Paternity သို့မဟုတ် Marriage Leave ဖွင့်ပေးနိုင်ပါသည်။',
          'Medical Documents နှင့် Other Documents — HR က တောင်းသော အခြားစာရွက်စာတမ်းများ။',
        ],
      },
      {
        text: 'တိကျမှုရှိစေရန် အမည်၊ ကိုယ်ရေးနံပါတ်၊ လစာနှင့် ဘဏ်အကောင့်ကဲ့သို့ အချို့အချက်များကို HR က ထိန်းသိမ်းပါသည်။ ဘဏ်အကောင့်ပြောင်းရန် တိုက်ရိုက်မပြင်ဘဲ Documents → Banking Documents တွင် ဘဏ်စာရွက်စာတမ်း တင်ပါ။',
      },
      {
        heading: 'ကျွမ်းကျင်မှုမြှင့်တင်ခြင်း (worker များ)',
        items: [
          'Worker များ၏ Profile တွင် “Skills Upgrading” tab ရှိပြီး skill level၊ စုစုပေါင်းဆောက်လုပ်ရေးအတွေ့အကြုံ၊ လစဉ်နိုင်ငံခြားလုပ်သား levy နှင့် မူရင်းနိုင်ငံ စသည့် construction classification ကို ပြပါသည်။',
          '“Current BCA Registrations” တွင် CoreTrade, Multi-skilling စသည့် trade registration နှင့် သက်တမ်းကုန်ရက်များကို ပြပြီး မကြာမီကုန်မည် သို့မဟုတ် ကုန်ပြီးပါက သတိပေးပါသည်။',
          '“Upgrade Pathways” တွင် သင်အရည်အချင်းပြည့်နိုင်သည့် လမ်းကြောင်းများနှင့် လိုအပ်ချက်တစ်ခုစီ (အတွေ့အကြုံ၊ လစာ၊ skills assessment) ကို စစ်ပေးသဖြင့် upgrade အတွက် လိုသေးသည်ကို မြင်နိုင်ပါသည်။',
          'ဤ tab သည် ဖတ်ရန်သာ ဖြစ်သည်။ အချက်အလက်မှားနေသည်ဟု ထင်ပါက သို့မဟုတ် upgrade လုပ်လိုပါက HR ကို ပြောပါ။',
        ],
      },
      {
        heading: 'Digital Name Card (staff နှင့် director များ)',
        items: [
          '“Legal & Compliance” tab သို့သွားပြီး “Digital Name Card Consent” ကိုရှာပါ။',
          'မျှဝေလိုသော လုပ်ငန်းအချက်အလက်များ (ဥပမာ designation, department, work email/phone) ကို ဖွင့်ပါ။ သင့်အမည်အပြည့်အစုံ အမြဲပါဝင်ပါမည်။',
          'ရွေးထားသောအချက်များကို သီးသန့် link နှင့် QR code မှတစ်ဆင့် အများကြည့်နိုင်မည်ကို လက်ခံကြောင်း tick လုပ်ပြီး “Activate Name Card” ကိုနှိပ်ပါ။',
          'ထို့နောက် “Name Card” tab ပေါ်လာပြီး QR code မျှဝေခြင်း၊ link copy လုပ်ခြင်း၊ card ခေတ္တပိတ်ခြင်း သို့မဟုတ် link အသစ်ထုတ်ခြင်း လုပ်နိုင်ပါသည်။',
        ],
      },
      {
        text: 'Digital name card ကို မိမိဆန္ဒဖြင့်သာ ဖွင့်ပြီး သင့်သဘောတူညီချက် လိုပါသည်။ သင် activate မလုပ်မချင်း မည်သည့်အရာမှ မမျှဝေပါ။ NRIC/FIN၊ passport၊ အိမ်လိပ်စာ၊ ကိုယ်ပိုင်အီးမေးလ်၊ လစာ စသည့် လျှို့ဝှက်အချက်များ ဘယ်တော့မှ မပါဝင်ပါ။ သဘောတူညီချက်ကို အချိန်မရွေး ရုပ်သိမ်းနိုင်ပါသည်။',
      },
    ],
  },

  'staff-directory': {
    title: 'ဝန်ထမ်းလမ်းညွှန်',
    summary: 'လုပ်ဖော်ကိုင်ဖက်များကို ရှာပြီး ကုမ္ပဏီဖွဲ့စည်းပုံကို ကြည့်ပါ။',
    routeLabel: 'Staff Directory ဖွင့်ရန်',
    blocks: [
      {
        heading: 'လုပ်ဖော်ကိုင်ဖက် ရှာရန်',
        items: [
          'ဘေးဘားမှ “Staff Directory” ကို ဖွင့်ပါ။',
          'အမည်၊ Staff ID၊ အလုပ်အီးမေးလ် သို့မဟုတ် designation ဖြင့် ရှာပါ။',
          'ဌာနအလိုက် စစ်ထုတ်ရန် filter ခလုတ်ကို သုံးပါ။',
          'မည်သူ့ကိုမဆို နှိပ်၍ အလုပ်အီးမေးလ်နှင့် ဖုန်းပါသော card ကိုဖွင့်ပါ (နှိပ်၍ အီးမေးလ်ပို့ သို့မဟုတ် ဖုန်းခေါ်နိုင်သည်)။',
        ],
      },
      {
        heading: 'ကြည့်ရှုနိုင်သည့် ပုံစံများ',
        items: [
          'Grid View — လုပ်ဖော်ကိုင်ဖက် card များ (မူလပုံစံ)။',
          'List View — Reporting Officer ပါသော ကျစ်လျစ်သည့် ဇယား။',
          'Organization Chart — reporting hierarchy ကိုကြည့်ပြီး PDF အဖြစ် download လုပ်နိုင်သည်။',
        ],
      },
      {
        text: 'အလုပ်ဆိုင်ရာ ဆက်သွယ်ရန်အချက်များသာ ပြပါသည်။ ကိုယ်ပိုင်ဖုန်း၊ အိမ်လိပ်စာနှင့် ကိုယ်ရေးနံပါတ်များကို လုပ်ဖော်ကိုင်ဖက်များ ဘယ်တော့မှ မမြင်နိုင်ပါ။',
      },
    ],
  },

  'my-assets': {
    title: 'ကျွန်ုပ်၏ ကုမ္ပဏီပစ္စည်းများ',
    summary: 'သင့်ထံ အပ်နှံထားသော ကုမ္ပဏီပစ္စည်းများကို ကြည့်ပြီး လွှဲပြောင်း/ပြန်အပ်ခြင်း လုပ်ပါ။',
    routeLabel: 'My Assets ဖွင့်ရန်',
    blocks: [
      {
        heading: 'သင်မြင်ရမည့်အရာများ',
        items: [
          '“My Assets” tab — လက်ရှိ သင့်ထံအပ်နှံထားသော ပစ္စည်းအားလုံးကို IT, Access, Fleet စသည့် category အလိုက် အုပ်စုခွဲပြသည်။',
          '“Transactions” tab — သင်လုပ်ဆောင်ရန် လိုသောအရာများနှင့် အတိတ် asset မှတ်တမ်း။ စောင့်နေသောအရေအတွက်ကို badge ဖြင့် ပြသည်။',
        ],
      },
      {
        heading: 'သင့်အား ပေးထားသောပစ္စည်းကို လက်ခံကြောင်း အတည်ပြုရန်',
        items: [
          '“Transactions” tab သို့ သွားပါ။',
          '“Needs your action” အောက်ရှိ ပစ္စည်းကိုရှာပြီး “Acknowledge receipt” ကိုနှိပ်ပါ။',
          'တာဝန်ယူမှုကြေညာချက်ကို ဖတ်ပြီး tick လုပ်ကာ အတည်ပြုပါ။ ထိုပစ္စည်းသည် “My Assets” အောက်တွင် ပေါ်လာပါမည်။',
        ],
      },
      {
        heading: 'လုပ်ဖော်ကိုင်ဖက်ထံမှ လွှဲပြောင်းမှု လက်ခံရန်',
        items: [
          '“Transactions” တွင် ဝင်လာသော transfer ကိုဖွင့်ပြီး “Accept” ကိုနှိပ်ပါ။',
          'ပစ္စည်းအခြေအနေ (New / Good / Fair / Poor / Faulty) ကို ရွေးပါ။',
          'ပစ္စည်းဓာတ်ပုံ အနည်းဆုံးတစ်ပုံ ထည့်ပြီး “Accept Transfer” ကိုနှိပ်ပါ။',
        ],
      },
      {
        heading: 'ပစ္စည်း ပြန်အပ်ရန်',
        items: [
          '“My Assets” တွင် ပစ္စည်းကိုဖွင့်ပြီး “Return to Inventory” ကိုနှိပ်ပါ။',
          'အကြောင်းပြချက်ရွေးပြီး လိုအပ်ပါက မှတ်ချက်ထည့်ကာ “Request Return” ကိုနှိပ်ပါ။',
          'Asset custodian က ပစ္စည်းအမှန်တကယ် ပြန်အပ်မှုကို အတည်ပြုပြီးမှ ပြီးဆုံးပါမည်။',
        ],
      },
      {
        text: 'Asset ကို လက်ခံကြောင်း အတည်ပြုသည့်အခါ system က သင့်မှတ်တမ်းအတွက် လက်မှတ်ပါ acknowledgement letter (PDF) ထုတ်ပေးပါသည်။ Asset ကိုဖွင့်၍ “View acknowledgement letter” ကိုနှိပ်ပြီး အချိန်မရွေး ကြိုကြည့် သို့မဟုတ် download လုပ်နိုင်ပါသည်။',
      },
      {
        text: 'Transfer နှင့် return များကို ၇ ရက်အတွင်း မပြီးစီးပါက သက်တမ်းကုန်ပါမည်။ “(Expiring soon!)” ဟု မှတ်ထားသောအရာများသည် ၂၄ နာရီအောက်သာ ကျန်ပါသည်။',
      },
    ],
  },

  payslips: {
    title: 'လစာဖြတ်ပိုင်းများ',
    summary: 'အသေးစိတ်လစာရှင်းတမ်းများကို ကြည့်ပြီး download လုပ်ပါ။',
    routeLabel: 'Payslips ဖွင့်ရန်',
    blocks: [
      {
        heading: 'လစာဖြတ်ပိုင်း ကြည့်ရန်နှင့် download လုပ်ရန်',
        items: [
          'ဘေးဘားမှ “Payslips” ကို ဖွင့်ပါ။',
          '“Choose a month” အောက်တွင် လိုသောနှစ်နှင့်လကို ရွေးပါ (payslip ရှိသောလများကို အရောင်ပြထားသည်)။',
          'ဝင်ငွေ၊ နုတ်ငွေနှင့် အသားတင်လစာ အသေးစိတ်ကို ကြည့်ရန် “Preview” ကိုနှိပ်ပါ။',
          'Download လုပ်ရန် “PDF” ကိုနှိပ်ပါ။ Last 3 / 6 / 12 months preset များဖြင့် လအများအပြားကို PDF တစ်ခုတည်းအဖြစ် ပေါင်းနိုင်ပါသည်။',
        ],
      },
      {
        heading: 'သိထားသင့်သောအချက်များ',
        items: [
          'အခြားသူများ သင့်မျက်နှာပြင်ကို မြင်နိုင်သည့်အခါ ငွေပမာဏကို ဖျောက်/ပြရန် မျက်လုံးပုံကို သုံးပါ။',
          'ထိုလ၏ payroll ကို အတည်ပြုပြီး ထုတ်ပေးမှသာ payslip ပေါ်ပါသည်။ အဆင်သင့်ဖြစ်သည့်အခါ အသိပေးချက် ရပါမည်။',
          'နှစ်စဉ်စုစုပေါင်း card တွင် ထိုနှစ်၏ အသားတင်လစာ၊ စုစုပေါင်းလစာ၊ နုတ်ငွေနှင့် အချိန်ပိုကို ပြပါသည်။',
        ],
      },
      {
        text: 'Digital payslip portal ကို လက်ရှိ worker များအတွက် အသုံးပြုနိုင်ပါသည်။ Staff ဖြစ်ပြီး “Coming Soon” ဟု မြင်ရပါက သင့် online payslip များကို ပြင်ဆင်နေဆဲ ဖြစ်ပါသည်။',
      },
    ],
  },

  'petty-cash': {
    title: 'အသေးစားအသုံးစရိတ် တောင်းခံမှုများ',
    summary: 'အသုံးစရိတ်တောင်းခံမှုများ တင်ပြီး အခြေအနေကို စောင့်ကြည့်ပါ။',
    routeLabel: 'Petty Cash ဖွင့်ရန်',
    blocks: [
      {
        text: 'Petty Cash သည် သီးခြား application အဖြစ် လည်ပတ်ပါသည်။ ဘေးဘားရှိ “Petty Cash Claims” ကိုနှိပ်လျှင် single sign-on ဖြင့် အလိုအလျောက် အကောင့်ဝင်ပြီး claim တင်/စောင့်ကြည့်နိုင်သည့် Petty Cash app ကို ဖွင့်ပေးပါမည်။ အလိုအလျောက် မသွားပါက မျက်နှာပြင်ရှိ “Open Petty Cash” ကိုနှိပ်ပါ။',
      },
      {
        text: 'သွားကုသစရိတ် claim (Employee Handbook Clause 8) သည် အတည်ပြုခန့်ထားပြီးသော staff အတွက်သာ ဖြစ်သည်။ Probation အတွင်း အခြား petty cash claim များ တင်နိုင်သေးပြီး အတည်ပြုခန့်ထားပြီးနောက် သွားကုသစရိတ်ကို တစ်နှစ် S$150 အထိ တောင်းနိုင်ပါမည်။',
      },
    ],
  },

  'ro-approvals': {
    title: 'Reporting Officer များအတွက် — ခွင့်အတည်ပြုခြင်း',
    summary: 'သင့်အဖွဲ့၏ ခွင့်တောင်းခံမှုများကို စစ်ပြီး အတည်ပြု သို့မဟုတ် ငြင်းပယ်ပါ။',
    routeLabel: 'Dashboard သို့ သွားရန်',
    blocks: [
      {
        text: 'ခွင့်အတည်ပြုမှုများကို သင့် Dashboard ရှိ “My Approvals” အောက်တွင် လုပ်ဆောင်ပါသည်။ တောင်းခံမှု စောင့်နေပါက 🔔 အသိပေးချက်နှင့် Dashboard ပေါ်တွင် အရေအတွက် badge ရပါမည်။',
      },
      {
        heading: 'တောင်းခံမှုကို အတည်ပြု သို့မဟုတ် ငြင်းပယ်ရန်',
        items: [
          'Dashboard ကိုဖွင့်ပြီး “My Approvals” card ကိုရှာပါ။',
          'တောင်းခံမှုတစ်ခုရှိ မျက်လုံးပုံကိုနှိပ်၍ “Leave Application Details” ဖွင့်ပါ။',
          'ရက်စွဲ၊ အကြောင်းပြချက်နှင့် “Team availability” မှတ်ချက်ကို စစ်ပါ (ထိုအချိန်တွင် အခြားသူများ ခွင့်ယူထားပါက သတိပေးပါသည်)။',
          'အတည်ပြုရန် အစိမ်းရောင် “Approve” ကိုနှိပ်ပါ။ အဆင့်များစွာရှိသော workflow တွင် နောက် approver ထံ ဆက်သွားပါမည်။',
          'ငြင်းပယ်ရန် “Reject” ကိုနှိပ်၍ အကြောင်းပြချက်ထည့်ပါ (မဖြစ်မနေလိုသည်)၊ ထို့နောက် “Confirm Rejection” ကိုနှိပ်ပါ။',
        ],
      },
      {
        heading: 'အထူးအခြေအနေများ',
        items: [
          'National Service Leave — approve/reject မလုပ်နိုင်ပါ။ သိရှိကြောင်း အတည်ပြုရန် “Acknowledge” ကိုနှိပ်ပါ။',
          'Sick / medical leave — HR က စာရွက်စာတမ်းကို အရင်စစ်ဆေးနေစဉ် ခလုတ်မရှိဘဲ “Awaiting HR Verification” ဟု မြင်နိုင်ပါသည်။',
          'အသိပေးချက်ကိုနှိပ်လျှင် တောင်းခံမှုကို တိုက်ရိုက်ဖွင့်ပါမည်။ လုပ်ဆောင်ပြီးသားဖြစ်ပါက Pending မဟုတ်တော့ကြောင်း ပြောပါမည်။',
        ],
      },
      {
        text: 'သင့်အဖွဲ့၏ attendance နှင့် wellbeing ကို ပိုကျယ်ပြန့်စွာ ကြည့်ရန် ဘေးဘားရှိ “My Team” ကိုသုံးပါ။ ခွင့်အတည်ပြုမှုကို My Team တွင်မဟုတ်ဘဲ Dashboard တွင် လုပ်ရပါသည်။',
      },
    ],
  },

  'my-team': {
    title: 'ကျွန်ုပ်၏အဖွဲ့ (Reporting Officer နှင့် HOD များ)',
    summary: 'အဖွဲ့၏ attendance၊ leave၊ ၇၂ နာရီ OT ကန့်သတ်ချက်နှင့် ၁၂ ရက် နားရက်စည်းကမ်းကို တစ်နေရာတည်းတွင် ကြည့်ပါ။',
    routeLabel: 'My Team ဖွင့်ရန်',
    blocks: [
      {
        heading: 'သင်မြင်နိုင်သည့်အရာများ',
        items: [
          'Overview — သင့်ထံ တိုက်ရိုက် report လုပ်သူများ၏ attendance နှင့် သတိပြုရန်အရာများ။',
          'Trends — အချိန်ကာလအလိုက် attendance ပုံစံများ။',
          'Leave Insights — လက်ရှိခွင့်ယူထားသူနှင့် အဖွဲ့၏ လာမည့်ခွင့်များ။',
          'Individual — အဖွဲ့ဝင်တစ်ဦးချင်း၏ attendance အသေးစိတ်ကို ကြည့်ပါ။',
          'Big Five — career နှင့် coaching ဆွေးနွေးမှုအတွက် personality profile ဖွင့်ပါ (အကြောင်းပြချက်လိုပြီး ဝန်ထမ်းက access log ကိုမြင်ရသည်)။ HOD နှင့် Deputy များသည် ဌာနတစ်ခုလုံး၊ RO များသည် direct report များကိုသာ ကြည့်နိုင်သည်။',
          'Overtime — workman များအတွက် MOM လစဉ် ၇၂ နာရီ OT ကန့်သတ်ချက်သို့ အဖွဲ့၏ နီးကပ်မှု (အောက်တွင်ကြည့်ပါ)။',
          'Rest Day — MOM ၁၂ ရက် ဆက်တိုက်အလုပ်လုပ်မှု ကန့်သတ်ချက်နှင့် အဖွဲ့၏ အခြေအနေ (အောက်တွင်ကြည့်ပါ)။',
          'HOD များတွင် “Department” tab လည်း ရှိပြီး “Direct Reports” နှင့် ဌာနတစ်ခုလုံးအကြား ပြောင်းနိုင်သည်။',
        ],
      },
      {
        heading: 'Rest Day သို့မဟုတ် Overtime စောင့်ကြည့်မှု ဖွင့်ရန်',
        items: [
          'ဘေးဘားတွင် “My Team” ကိုနှိပ်ပါ (သို့မဟုတ် /team-dashboard သို့ တိုက်ရိုက်သွားပါ)။',
          'စာမျက်နှာအပေါ်ရှိ “Rest Day” သို့မဟုတ် “Overtime” tab ကိုနှိပ်ပါ။',
          'တိုက်ရိုက် link ကို bookmark သို့မဟုတ် share လုပ်နိုင်သည် — နားရက်စောင့်ကြည့်ရန် /team-dashboard?tab=restday၊ ၇၂ နာရီ view အတွက် /team-dashboard?tab=overtime ဖြစ်သည်။',
          'ဇယားစစ်ထုတ်ရန် summary card (ဥပမာ “Action Required”) ကိုနှိပ်ပါ၊ သို့မဟုတ် လူတစ်ဦး၏ အသေးစိတ်ဖွင့်ရန် row ပေါ်ရှိ မျက်လုံးပုံကိုနှိပ်ပါ။',
        ],
      },
      {
        heading: 'Rest Day tab — ၁၂ ရက် ကန့်သတ်ချက် (MOM Employment Act s36)',
        items: [
          'အဖွဲ့ဝင်တစ်ဦးစီ နားရက်မရှိဘဲ ဆက်တိုက်အလုပ်လုပ်သည့် calendar ရက်အရေအတွက်ကို ပြသည်။ ဥပဒေအရ အများဆုံး ၁၂ ရက်ဖြစ်ပြီး ၁၃ ရက်မြောက် ဆက်တိုက်အလုပ်လုပ်မှ စည်းကမ်းချိုးဖောက်မှု ဖြစ်သည်။',
          'အခြေအနေအရောင်များ — OK (၇ ရက်အောက်), Watch (၇–၈), Warning (၉–၁၁), Critical (၁၂ — ကန့်သတ်ချက်အဆုံး၊ နောက်အလုပ်ရက်မတိုင်မီ နားရမည်), Violated (၁၃ နှင့်အထက်)။',
          'ကန့်သတ်ချက်နီးလာသူအတွက် စည်းကမ်းမချိုးဖောက်ဘဲ နောက်ဆုံးနားရမည့်ရက်ကို “Rest by …” အဖြစ် ဇယားတွင် ပြသည်။',
          'လူတစ်ဦး၏ အသေးစိတ်တွင် ရက် ၃၀ အလုပ်/နား timeline၊ alert history နှင့် “Rest day required by” ကို schedule၊ approved leave နှင့် public holiday အပေါ်မူတည်သော “Projected next rest day” နှင့် နှိုင်းယှဉ်ပြသည်။ ရက်များမကိုက်ပါက deadline မတိုင်မီ နားရက်သတ်မှတ်ရန် system က သတိပေးသည်။',
          'Manager များအတွက် ဖတ်ရန်သာ ဖြစ်ပြီး ဤနေရာတွင် alert ကို acknowledge မလုပ်နိုင်ပါ (HR က admin Rest Day Monitoring စာမျက်နှာတွင် လုပ်ပါသည်)။ ပြဿနာကို ကြိုမြင်ပြီး အဖွဲ့နှင့် နားရက်စီစဉ်ရန် ဤ tab ကိုသုံးပါ။',
        ],
      },
      {
        heading: 'Overtime tab — လစဉ် ၇၂ နာရီ ကန့်သတ်ချက် (MOM Part IV)',
        items: [
          'အဖွဲ့ရှိ workman များအတွက် MOM လစဉ် ၇၂ နာရီ ကန့်သတ်ချက်ထဲသို့ ရေတွက်သည့် OT နာရီကို စောင့်ကြည့်သည်။ အချိန်ပိုကျော်လွန်သည့်နာရီသာ ရေတွက်ပြီး နားရက်နှင့် public holiday ပေါ်ရှိ ပုံမှန်နာရီများ မပါပါ။',
          'သင့်လက်အောက်တွင် OT ခံစားခွင့်ရှိသော workman အနည်းဆုံးတစ်ဦး ရှိမှသာ tab ပေါ်ပါမည်။ Staff-class employee များကိုသာ စီမံပါက ဤ tab ကို မမြင်ရပါ။',
          'Dropdown မှ လရွေးပါ (မူလအားဖြင့် လက်ရှိလ)။ လက်ရှိလ မပြီးသေးစဉ် နောက်ဆုံးကိန်းဂဏန်းလိုပါက refresh ခလုတ်ကို သုံးပါ။',
          'အခြေအနေအဆင့်များ — OK (၄၈ နာရီအောက်), At Risk (၄၈–၆၀), Critical (၆၀–၇၂), Exceeded (၇၂ ကျော်)။ လက်ရှိလတွင် ခန့်မှန်းချက်အရ လမကုန်မီ ကန့်သတ်ချက်ရောက်နိုင်လျှင် “Watch” သို့မဟုတ် “Projected Exceed” ကိုလည်း မြင်နိုင်သည်။',
          'လူတစ်ဦး၏ နေ့စဉ်အသေးစိတ်နှင့် ၁၂ လ trend ကိုဖွင့်ရန် row ကိုနှိပ်ပါ။ စည်းကမ်းလိုက်နာမှုအတွက် အရေးကြီးသည့် နံပါတ်မှာ “72h Cap OT” column ဖြစ်သည်။',
          'Workman များသည် မိမိအခြေအနေကို Attendance စာမျက်နှာတွင် ကြည့်နိုင်သည် (“Clock In & Out” ကိုကြည့်ပါ)။ Manager များက အဖွဲ့တစ်ခုလုံးကို ဤ tab ဖြင့် စောင့်ကြည့်ပါသည်။',
        ],
      },
      {
        text: 'My Team သည် အချက်အလက်ကြည့်ရန်သာ ဖြစ်သည်။ ခွင့်အတည်ပြု/ငြင်းပယ်ရန် Dashboard ရှိ “My Approvals” ကိုသုံးပါ (“Reporting Officer များအတွက် — ခွင့်အတည်ပြုခြင်း” ကိုကြည့်ပါ)။',
      },
    ],
  },

  'self-service': {
    title: 'Self-Service ဗဟိုနေရာ',
    summary: 'တောင်းခံမှုများ၊ အရင်းအမြစ်များ၊ ပွဲများနှင့် အခြားအရာများအတွက် တစ်နေရာတည်း။',
    routeLabel: 'Self-Service ဖွင့်ရန်',
    blocks: [
      {
        heading: 'သင်တွေ့ရမည့်အရာများ',
        items: [
          'Requests & Approvals — Request Letters, Nightwork, Rest Day & PH Work, Course Requests နှင့် Overseas Travel Notice။ သင့်အခန်းကဏ္ဍအလိုက် Worker Trade Transfer, Work Pass Decisions နှင့် offboarding card များလည်း ပေါ်ပါမည်။',
          'Resources — Employee Handbook, Company Policies နှင့် Training Materials။',
          'Events — Meetings & Training ကို ကျင်းပပြီး တက်ရောက်မှု မှတ်တမ်းတင်ခြင်း။',
          'Personal Insights (ဆန္ဒအလျောက်၊ လျှို့ဝှက်) — Big Five profile။',
          'Report a Concern — အမည်မဖော်လိုသော Misconduct Reporting။',
        ],
      },
      {
        text: 'ဘေးဘားမှ “Self-Service” ကိုဖွင့်ပြီး မည်သည့် card ကိုမဆို နှိပ်ပါ။ Worker Trade Transfer ကဲ့သို့ အချို့ card များသည် သင့်အခန်းကဏ္ဍနှင့် သက်ဆိုင်မှသာ ပေါ်ပါမည်။',
      },
    ],
  },

  letters: {
    title: 'စာတောင်းခံခြင်း',
    summary: 'ကုမ္ပဏီ/HR စာများ တောင်းခံပြီး အဆင်သင့်ဖြစ်သည်အထိ အခြေအနေ စောင့်ကြည့်ပါ။',
    routeLabel: 'Request Letters ဖွင့်ရန်',
    blocks: [
      {
        heading: 'စာတစ်စောင် တောင်းခံရန်',
        items: [
          'Self-Service → “Request Letters” ကို ဖွင့်ပါ။',
          '“Create New Request” အောက်တွင် Letter Type အဖြစ် “Employment Verification” သို့မဟုတ် “Home Leave Authorization” ကို ရွေးပါ။',
          'Employment Verification အတွက် Purpose (ဥပမာ Visa Application, Bank Loan, Tenancy Agreement) ကိုရွေးပါ။ “Other” ရွေးလျှင် အသေးစိတ်ရေးပါ။',
          '“Create Request” ကိုနှိပ်ပြီး “Submit Request” ဖြင့် အတည်ပြုပါ။ HR ထံ အတည်ပြုရန် ပို့ပါမည်။',
        ],
      },
      {
        heading: 'အခြေအနေကြည့်ရန်နှင့် download လုပ်ရန်',
        items: [
          'သင့်တောင်းခံမှုများသည် “My Requests” အောက်တွင် Pending Approval, Approved, Rejected သို့မဟုတ် Cancelled အဖြစ် ပေါ်ပါမည်။',
          'Approved ဖြစ်ပြီးလျှင် preview သို့မဟုတ် download ပုံကို သုံး၍ PDF စာ ရယူပါ။',
          'စာများသည် ရက် ၆၀ သက်တမ်းရှိသည်။ သက်တမ်းကုန်ပါက အချက်အလက်ဖြည့်ထားသော တောင်းခံမှုအသစ်အတွက် “Request a new letter” ကိုသုံးပါ။',
          'Pending Approval ဖြစ်နေစဉ် တောင်းခံမှုကို cancel လုပ်နိုင်ပါသည်။',
        ],
      },
    ],
  },

  'shift-requests': {
    title: 'Nightwork နှင့် Rest Day အလုပ် တောင်းခံမှုများ',
    summary: 'ည၊ နားရက် သို့မဟုတ် PH တွင် အလုပ်လုပ်ပြီး နောက်မနက်/နောက်နေ့ နားချိန်ရမည့်အခါ worker များအတွက် ခွင့်ပြုချက်ယူပါ။',
    routeLabel: 'Nightwork Requests ဖွင့်ရန်',
    blocks: [
      {
        text: 'ဤတောင်းခံမှုများကို မိမိအတွက်မဟုတ်ဘဲ worker အဖွဲ့ကိုယ်စား တင်ရပါသည်။ Worker များ မတင်ရဘဲ အတည်ပြုပြီး schedule ကို “My Assignments” tab တွင် ကြည့်ရပါမည်။ (Rest Day & PH work ကို Self-Service → “Rest Day & PH Work Request” တွင် တွေ့နိုင်သည်။)',
      },
      {
        heading: 'မည်သူ တင်သင့်သလဲ',
        items: [
          'Nightwork — Trade Leader, Manager သို့မဟုတ် HR က ခွင့်ပြုထားသူ။ Reporting Officer နှင့် HOD များသည် Trade Leader သို့မဟုတ် Manager လည်း ဖြစ်မှသာ တင်နိုင်သည်။',
          'Rest Day / PH Work — Trade Leader, Manager, Reporting Officer (direct report ရှိသူ) သို့မဟုတ် HR က ခွင့်ပြုထားသူ။',
          'ဌာန၏ Deputy HOD က အရင်အတည်ပြုပြီး ထို့နောက် HOD က အတည်ပြုပါသည်။',
        ],
      },
      {
        heading: 'ဘယ်အချိန် တောင်းရမည်',
        items: [
          'ဆုံးဖြတ်နည်း — အလုပ်ကြောင့် နောက်မနက် သို့မဟုတ် နောက်နေ့တွင် နားချိန်/recovery (AM Only သို့မဟုတ် Full Day) ရမည့်အခါ တောင်းပါ။ ဤ recovery ကြောင့် ပုံမှန် OT နှင့် ကွာခြားခြင်း ဖြစ်သည်။',
          'Nightwork — အဖွဲ့က ည shift အလုပ်လုပ်သည့်အခါ သို့မဟုတ် ပုံမှန်အချိန်ကျော်၍ ညအထိ ဆက်လုပ်ပြီး နောက်နေ့နားမည့်အခါ သုံးပါ။ ပုံမှန်နေ့အပြီးဆက်လုပ်လျှင် “Extension”၊ ည shift က နေ့ shift အစားထိုးလျှင် “Standard” ရွေးပါ။ ညဉ့်နက်မှပြီးသော်လည်း recovery မယူဘဲ နောက်နေ့ပုံမှန်တစ်နေ့လုံး အလုပ်ဆင်းရလျှင် Nightwork မသုံးပါနှင့်။ ထိုအရာသည် ပုံမှန် OT ဖြစ်သည်။',
          'Rest Day / PH Work — worker များ နားရက် သို့မဟုတ် public holiday တွင် အလုပ်လုပ်သည့်အခါတိုင်း သုံးပါ။ Worker များသည် schedule အရ တနင်္လာမှ စနေ ၆ ရက်လုပ်သောကြောင့် ပုံမှန်နားရက်မှာ တနင်္ဂနွေဖြစ်သည်။ Shift ကြောင့် နောက်မနက်/နောက်နေ့ နားရန်လိုပါက Full Day သို့မဟုတ် AM Only ရွေးပါ။ နောက်နေ့ ပုံမှန်အလုပ်ရက်ဖြစ်ပါကသာ None ရွေးပါ။',
          'အလုပ်ချိန်၊ recovery နှင့် worker များကို ကြိုတင်အတည်ပြုနိုင်ရန် စောစောတင်ပါ။ အရေးပေါ်ဖြစ်ပါက နောက်ကျရက်စွဲဖြင့် တင်နိုင်သော်လည်း အကြောင်းပြချက်ရေးရမည်။ Payroll အတွက် lock လုပ်ပြီးသောရက်များကို ပိတ်ထားသဖြင့် HR ကို ဆက်သွယ်ပါ။',
        ],
      },
      {
        text: 'Worker များသည် ပုံမှန်အတိုင်း အမြဲ Clock In/Out လုပ်ရမည်။ ထိုအချက် မပြောင်းပါ။ Recovery သည် nightwork သို့မဟုတ် rest-day/PH work ပြီးနောက်နေ့ ဖြစ်သည်။ AM Only ဆိုလျှင် နေ့လယ်စာစားပြီးမှ ပြန်ဝင်ရမည်၊ Full Day ဆိုလျှင် တစ်နေ့လုံး နားရမည်။',
      },
      {
        heading: 'တောင်းခံမှုတင်နည်း',
        items: [
          'Self-Service → “Nightwork Requests” သို့မဟုတ် “Rest Day & PH Work Request” ကိုဖွင့်ပြီး “New Request” tab သို့သွားပါ။',
          'Step 1 — Project & Description: project ရွေးပြီး လုပ်မည့်အလုပ်ကို ရေးပါ။',
          'Step 2 — Dates & Times: ရက်စွဲ၊ စ/ဆုံးချိန်နှင့် recovery day (Full Day, AM Only သို့မဟုတ် rest day work အတွက် None) ရွေးပါ။',
          'Step 3 — Personnel: worker များကို အမည်/Staff ID ဖြင့်ရှာ၍ ထည့်ပြီး safety personnel ရှိပါက ထည့်ပါ။',
          'Step 4 — Review & Submit: အကျဉ်းချုပ်စစ်ပြီး “Submit for Approval” ကိုနှိပ်ပါ။',
          '“My Requests” အောက်တွင် Pending Dy HOD → Pending HOD → Approved အဖြစ် တိုးတက်မှုကို ကြည့်ပါ။',
        ],
      },
      {
        text: 'Rest day work တွင် MOM ၏ ၁၂ ရက် ဆက်တိုက်အလုပ်လုပ်မှု ကန့်သတ်ချက်ကို စစ်ပါသည်။ Worker တစ်ဦး ကန့်သတ်ချက်ကျော်မည်ဆိုပါက ဆက်လုပ်ရန် အကြောင်းပြချက်အဖြစ် override reason ထည့်ရပါမည်။',
      },
    ],
  },

  'trade-transfer': {
    title: 'Worker Trade လွှဲပြောင်းခြင်း',
    summary: 'သင်ဦးဆောင်သော trade သို့ worker များကို ပါဝင်သူအားလုံး၏ အသိအမှတ်ပြုမှုဖြင့် ရွှေ့ပါ။',
    routeLabel: 'Worker Trade Transfer ဖွင့်ရန်',
    blocks: [
      {
        text: 'Trade Leader တစ်ဦးက သူဦးဆောင်သော trade ထဲသို့ worker များခေါ်ရန် transfer တင်ပါသည်။ Worker တစ်ဦးစီကို လက်ရှိ Trade Leader၊ worker နှင့် HOD တို့က အစဉ်လိုက် အသိအမှတ်ပြုရပါသည်။ HR သည် ဖတ်ရှုစောင့်ကြည့်ခွင့်သာရှိပြီး approval chain တွင် မပါပါ။',
      },
      {
        heading: 'မည်သူနှင့် ဘယ်အချိန်',
        items: [
          'တောင်းခံသူ — worker များကို လက်ခံမည့် Trade Leader (incoming leader)။ HR admin များတွင် ဖတ်ရန်သာဖြစ်သော “All Requests” view ရှိသည်။',
          'အသိအမှတ်ပြုသူ — worker ၏ လက်ရှိ Trade Leader၊ ထို့နောက် worker၊ နောက်ဆုံး HOD ဟူ၍ အစဉ်လိုက်ဖြစ်သည်။',
          'အသုံးပြုချိန် — worker တစ်ဦး သို့မဟုတ် အများကို လက်ရှိ trade မှ သင်ဦးဆောင်သော trade သို့ ရွှေ့ရန် (ဥပမာ လူအင်အား သို့မဟုတ် project လိုအပ်ချက်)။',
        ],
      },
      {
        heading: 'Transfer တောင်းခံနည်း',
        items: [
          'Self-Service → “Worker Trade Transfer” → “Request Transfer” tab ကို ဖွင့်ပါ။',
          'သင်ဦးဆောင်သော trade တစ်ခုထက်ပိုပါက ရွှေ့မည့် trade ကိုရွေးပြီး effective date (ယနေ့ သို့မဟုတ် နောက်ရက်) ရွေးပါ။',
          'Worker များကို အမည်၊ Staff ID သို့မဟုတ် trade ဖြင့်ရှာ၍ ထည့်ပြီး အကြောင်းပြချက်ရေးပါ။',
          '“Submit Request” ကိုနှိပ်ပါ။ Worker တစ်ဦးစီကို “My Requests” အောက်တွင် စောင့်ကြည့်နိုင်ပြီး လုပ်ငန်းစဉ် မပြီးသေးစဉ် “Cancel Request” လုပ်နိုင်ပါသည်။',
        ],
      },
      {
        heading: 'အသိအမှတ်ပြုရန် တောင်းဆိုခံရပါက',
        items: [
          'Notification၊ Dashboard card သို့မဟုတ် “My Inbox” tab မှ တောင်းခံမှုကိုဖွင့်ပြီး “Review” ကိုနှိပ်ပါ။',
          'Worker များ — သိရှိလက်ခံကြောင်း “Accept” ကိုနှိပ်ပါ၊ သို့မဟုတ် transfer ကိုရပ်ရန် “Decline” ကိုနှိပ်ပါ (ငြင်းပယ်ရန် အကြောင်းပြချက်လိုသည်)။',
          'လက်ရှိ Trade Leader / HOD — “Approve” သို့မဟုတ် “Reject” ကိုနှိပ်ပါ (Reject အတွက် အကြောင်းပြချက်လိုသည်)။',
          'ဆုံးဖြတ်ချက် မှတ်တမ်းတင်ရန် “Confirm” ကိုနှိပ်ပါ။',
        ],
      },
      {
        text: 'Worker တစ်ဦးစီကို သီးခြားကိုင်တွယ်ပါသည်။ တစ်ဦးငြင်းပယ်ခံရသော်လည်း အုပ်စုထဲရှိ အခြားသူများ ဆက်လုပ်ပါမည်။ သုံးဦးလုံး အသိအမှတ်ပြုပြီးလျှင် trade ပြောင်းမှုကို စီစဉ်ထားပြီး effective date တွင် အကောင်အထည်ဖော်ပါမည်။',
      },
    ],
  },

  'passport-return': {
    title: 'နိုင်ငံကူးလက်မှတ် ပြန်လည်ပေးအပ်ခြင်း',
    summary: 'HR က ယခင်ထိန်းသိမ်းထားသော passport များကို ပြန်ပေးပြီး worker တစ်ဦးစီ၏ လက်ခံရရှိမှု မှတ်တမ်းတင်ပါ။',
    routeLabel: 'Passport Return ဖွင့်ရန်',
    blocks: [
      {
        heading: 'ဤ campaign ၏ လုပ်ဆောင်ချက်',
        items: [
          'Passport မိမိထံရှိပြီးသားဟု HR အတည်ပြုထားသူများမှလွဲ၍ active worker အားလုံး၏ passport ကို HR က ထိန်းသိမ်းထားပါသည်။ ထိုသူများအတွက် physical return မရှိပါ။ Malaysian WP holder များသည် ဤ campaign တွင် မပါဝင်ပါ—၎င်းတို့၏ passport ကို မသိမ်းခဲ့သဖြင့် acknowledge လုပ်ရန်မလိုပါ။',
          'ထိန်းသိမ်းထားသော passport များကို worker ထံ အပြီးအပိုင် ပြန်ပေးပြီး ကုမ္ပဏီထံ ပြန်အပ်သိမ်းဆည်းရန် မလိုပါ။',
          'ခွင့်ယူနေသော worker များသည် ပြန်လာပြီးနောက် မူဝါဒကို acknowledge လုပ်ပါမည်။ Passport ကို ယခင်ကတည်းက ထုတ်ယူထားသူများသည် ယခု acknowledge လုပ်ရုံဖြစ်ပြီး ဒုတိယအကြိမ် physical handover မရှိပါ။',
          'Worker က စည်းကမ်းချက်များကို လက်မှတ်ထိုးခြင်း သို့မဟုတ် အသိအမှတ်ပြုခြင်းအပေါ် မူတည်၍ passport ပြန်ပေးခြင်းကို ဘယ်တော့မှ မတားမြစ်ရပါ။',
          'Acknowledge လုပ်ပြီးနောက် worker သည် Passport Return ကို အချိန်မရွေး ပြန်ဖွင့်၍ မှတ်တမ်းတင်ထားသော confirmations နှင့် acknowledge လုပ်ခဲ့သည့် ဘာသာစကား version အတိအကျကို ကြည့်နိုင်သည်။ အခြားဘာသာဖြင့် acknowledge လုပ်ထားပါက reference အတွက် English ကိုလည်း ပြောင်းကြည့်နိုင်ပြီး မှတ်တမ်းတင်ထားသော ဘာသာစကား မပြောင်းပါ။',
          'မှတ်ပုံတင်ထားသော record အားလုံးကို အသိအမှတ်ပြုပြီး သို့မဟုတ် သက်သေပါ exception ဖြင့် ဖြေရှင်းပြီးလျှင် campaign အလိုအလျောက် ပိတ်ပါမည်။',
        ],
      },
      {
        heading: 'Worker များအတွက် (passport ကို HR က ထိန်းသိမ်းထားပါက)',
        items: [
          'မူရင်း passport အဆင်သင့်ဖြစ်ကြောင်း HR အသိပေးသည်အထိ စောင့်ပါ။',
          'Portal တွင် မည်သည့်အရာကိုမှ အတည်မပြုမီ မူရင်း passport ကို လက်ခံယူပြီး စစ်ဆေးပါ။',
          'Passport Return ကိုဖွင့်၍ ဘာသာစကားရွေးပြီး passport နှင့် နိုင်ငံခြားခရီးသွားခြင်းဆိုင်ရာ တာဝန်များကို ဖတ်ပါ။',
          'မူရင်း passport ကို အမှန်တကယ် လက်ခံရရှိကြောင်း အတည်ပြုပြီး မူဝါဒကို အသိအမှတ်ပြုပါ။ သင်ဖတ်သော ဘာသာစကား version အတိအကျနှင့် အချိန်ကို audit record တွင် သိမ်းပါမည်။',
          'မိမိအတည်ပြုထားသမျှ၏ အပြည့်အစုံ copy ကိုလိုပါက PDF receipt ကို download လုပ်ပါ။ On-screen page ကို print မလုပ်ပါနှင့်။',
        ],
      },
      {
        heading: 'Worker များအတွက် (Home Leave / Urgent Leave ယူနေပြီးသားဖြစ်ပါက)',
        items: [
          'ခွင့်ယူနေစဉ် passport ကို မိမိနှင့်အတူ ထားပါ။ သွားယူရန် မလိုပါ။',
          'ခွင့်ပြီးဆုံးပြီးနောက် တောင်းဆိုလာသည့်အခါ Passport Return ကို ဖွင့်ပါ။',
          'မူရင်း passport မိမိထံ ရှိနေသေးကြောင်း အတည်ပြုပြီး မိမိဘာသာစကားဖြင့် မူဝါဒကို အသိအမှတ်ပြုပါ။',
        ],
      },
      {
        heading: 'Worker များအတွက် (passport ကို ယခင်ကတည်းက ထုတ်ယူထားပါက)',
        items: [
          'Renewal သို့မဟုတ် ကိုယ်ရေးကိစ္စအတွက် HR က passport ကို ယခင်ကတည်းက ပြန်ပေးထားပါက သွားယူရန်အဆင့် မရှိပါ။',
          'Campaign စတင်ပြီးနောက် Passport Return ကို ဖွင့်ပါ။',
          'မူရင်း passport မိမိထံ ရှိနေသေးကြောင်း အတည်ပြုပြီး မိမိဘာသာစကားဖြင့် မူဝါဒကို acknowledge လုပ်ပါ။',
        ],
      },
      {
        heading: 'HR administrator များအတွက်',
        items: [
          'Inventory စည်းမျဉ်းကို အတည်ပြုပြီး worker roster အပြည့်အစုံ (held, on leave သို့မဟုတ် already withdrawn) ကို ထည့်ပါ။',
          'Launch မလုပ်မီ English မူဝါဒနှင့် ဘာသာပြန်တစ်ခုစီကို management/legal စစ်ဆေးမှု ရယူပါ။',
          'Held cohort — HR က passport ပေးရန် အဆင်သင့်ဖြစ်လျှင် worker တစ်ဦး သို့မဟုတ် held passport အားလုံးကို ready ဟု မှတ်ပါ။ Worker တစ်ဦးစီကို လာယူရန် notification ပို့ပါမည်။ မူရင်းစာရွက်စာတမ်းကို worker အား အမှန်တကယ်ပေးပြီးမှ handover ကို မှတ်တမ်းတင်ပါ။',
          'ခွင့်ယူနေသောအုပ်စု — ခွင့်ပြီးသည်အထိ စောင့်ပါ။ ထို့နောက် record သည် မူဝါဒအသိအမှတ်ပြုရန်သာ “Ack due” သို့ ရွှေ့ပါမည်။',
          'Already-withdrawn cohort — launch ပြီးသည်နှင့် မူဝါဒ acknowledgement လိုအပ်ပြီး physical handover မရှိပါ။',
          'Already-withdrawn worker က campaign handover မတိုင်မီ မူရင်း passport ကို HR ထံ ပြန်အပ်ပါက “Passport now in the safe” ကို သုံးပါ။ Record သည် Physical return သို့ ရွှေ့ပါမည်။ Notification မပို့ပါနှင့်၊ passport ကို HR က ထိန်းထားစဉ် acknowledge လုပ်ရန် မတောင်းဆိုပါနှင့်။',
          'Acknowledged record တွင် “View acknowledgement receipt” ဖြင့် confirmations၊ acknowledgement အချိန်တွင် သတ်မှတ်ထားသော passport number/expiry၊ exact language snapshot၊ timestamp နှင့် English reference translation ကို ကြည့်ပါ။ Multi-page copy အပြည့်အစုံအတွက် Download PDF သုံးပြီး on-screen modal ကို print မလုပ်ပါနှင့်။',
          'Handover သို့မဟုတ် ခွင့်မှပြန်လာပြီးနောက် Portal acknowledgement မရနိုင်ပါက အသေးစိတ် exception ကို ဒုတိယ HR administrator အား သက်သေအဖြစ်ထား၍ မှတ်တမ်းတင်ပါ။ Passport ကို ပြန်မယူပါနှင့်။',
          'လုပ်ဆောင်ချက်တိုင်းကို ပြင်ဆင်၍မရသော campaign timeline နှင့် ဗဟို audit log တွင် သိမ်းထားပါသည်။',
        ],
      },
    ],
  },

  events: {
    title: 'အစည်းအဝေးနှင့် သင်တန်း တက်ရောက်မှု',
    summary: 'ပွဲတစ်ခု ကျင်းပပြီး အလိုအလျောက်ပြောင်းလဲသော QR code ဖြင့် တက်ရောက်မှု မှတ်တမ်းယူပါ။',
    routeLabel: 'Events ဖွင့်ရန်',
    blocks: [
      {
        text: 'ပွဲကျင်းပခြင်းသည် staff နှင့် director များအတွက် ဖြစ်သည်။ ပြင်ပဧည့်သည်များအပါအဝင် တက်ရောက်သူများသည် QR code ကို scan လုပ်ရုံဖြစ်ပြီး အထူးအသုံးပြုခွင့် မလိုပါ။',
      },
      {
        heading: 'ပွဲတစ်ခု ကျင်းပရန်',
        items: [
          'Self-Service → “Meetings & Training Attendance” ကိုဖွင့်ပြီး “New event” ကိုနှိပ်ပါ။',
          'ခေါင်းစဉ်၊ အမျိုးအစား (Meeting / Training / Briefing / Other)၊ ရက်စွဲနှင့် အချိန် ထည့်ပါ။ Project နှင့် location ကို လိုပါက ထည့်နိုင်သည်။',
          '“Create event” ကိုနှိပ်ပါ (Draft အဖြစ် စမည်)။ အဆင်သင့်ဖြစ်လျှင် “Activate & show QR” ကိုနှိပ်ပါ။',
          'ဖုန်း သို့မဟုတ် TV တွင် code ပြရန် “Present QR” ကိုနှိပ်ပါ။ လုံခြုံရေးအတွက် code သည် အလိုအလျောက် ပြောင်းပါသည်။',
          'ပြီးဆုံးလျှင် check-in ပိတ်ပြီး attendance record ကို မိမိအီးမေးလ်သို့ပို့ရန် “Close & email PDF” ကိုနှိပ်ပါ။ တစ်စုံတစ်ဦး လွတ်သွားပါက “Reopen for late check-ins” လုပ်နိုင်သည်။',
        ],
      },
      {
        heading: 'ပွဲတစ်ခုသို့ Check in လုပ်ရန်',
        items: [
          'ဖုန်းကင်မရာဖြင့် QR code ကို scan လုပ်ပါ။',
          'ဝန်ထမ်းများ — အတည်ပြုရန် အကောင့်ဝင်ပါ။ သင့်အချက်အလက်များကို ကြိုတင်ဖြည့်ထားပါမည်။',
          'ခွင့်ပြုထားသော ပြင်ပဧည့်သည် — “I’m an external attendee” ကိုရွေးပြီး အချက်အလက် ဖြည့်ပါ။',
          'မျက်နှာပြင်ပေါ်တွင် လက်မှတ်ထိုးပြီး (လက်မှတ်လိုသည်) “Check in” ကိုနှိပ်ပါ။',
        ],
      },
      {
        text: 'QR သည် စက္ကန့် ၂၀ တိုင်း အသစ်ပြောင်းသဖြင့် နောက်မှမျှဝေသော screenshot သည် အလုပ်မလုပ်ပါ။ Live code ကို တိုက်ရိုက် scan လုပ်ပါ။',
      },
    ],
  },

  whistleblowing: {
    title: 'အမည်မဖော်ဘဲ မသင့်လျော်သောလုပ်ရပ် တိုင်ကြားခြင်း',
    summary: 'မသင့်လျော်သောလုပ်ရပ်၊ လိမ်လည်မှု သို့မဟုတ် စည်းမျဉ်းချိုးဖောက်မှုကို လျှို့ဝှက်စွာ တိုင်ကြားပါ။',
    routeLabel: 'Misconduct Reporting ဖွင့်ရန်',
    blocks: [
      {
        text: 'သင့်တိုင်ကြားမှုသည် အမည်လုံးဝမဖော်ပါ။ သင်တင်သောအကြောင်းအရာကို HR Portal တွင် မသိမ်းဘဲ ခွင့်ပြုထားသော လွတ်လပ်သည့် third-party assessor ထံသာ ပို့ပါသည်။ အမည်နှင့် အီးမေးလ်သည် မဖြည့်လည်းရပြီး ဆက်သွယ်စေလိုမှသာ ထည့်ပါ။',
      },
      {
        heading: 'တိုင်ကြားနည်း',
        items: [
          'Self-Service → “Anonymous Misconduct Reporting” ကိုဖွင့်၍ သတိပြုရန်စာ ဖတ်ပြီး “Done” ကိုနှိပ်ပါ။',
          'နောက်ဆက်တွဲ ဆက်သွယ်စေလိုမှသာ အမည်/အီးမေးလ်ကို ရွေးချယ်ဖြည့်ပါ။',
          'မဖြစ်မနေလိုသောအချက်များ ဖြည့်ပါ — မည်သူပါဝင်သည်၊ ချိုးဖောက်မှုအမျိုးအစား၊ ဘာဖြစ်ခဲ့ပြီး ဘယ်အချိန်၊ ဘယ်နေရာ၊ အခြားမည်သူသိသည်နှင့် သင်မည်သို့သိလာသည်။',
          'အထောက်အထားစာရွက်စာတမ်း ရှိပါက ပူးတွဲပါ (မဖြစ်မနေမဟုတ်ပါ)။',
          'သင့်အချက်အလက် မှန်ကန်ကြောင်း အတည်ပြုသည့် box ကို tick လုပ်ပြီး “Submit” ကိုနှိပ်ပါ။',
        ],
      },
      {
        text: 'အတည်ပြုမျက်နှာပြင်တွင် reference code (ဥပမာ WB-YYYYMMDD-XXXXXX) ရပါမည်။ Portal တွင် ထပ်ရှာ၍မရသောကြောင့် code ကို မှတ်သားထားပါ။',
      },
    ],
  },

  'big-five': {
    title: 'Big Five ကိုယ်ရည်ကိုယ်သွေး Profile',
    summary: 'မိမိဆန္ဒဖြင့် လျှို့ဝှက်စွာ ဖြေဆိုပြီး ကိုယ်ပိုင်ရလဒ်ရရှိသည့် personality assessment။',
    routeLabel: 'Big Five Profile ဖွင့်ရန်',
    blocks: [
      {
        text: 'Big Five ကို ဖြေဆိုရန် လုံးဝ မိမိဆန္ဒအလျောက် ဖြစ်သည်။ သင့်အဖြေများကို encryption လုပ်ထားသည်။ Career ဆွေးနွေးမှုအတွက် HR၊ HOD၊ Deputy HOD နှင့် Reporting Officer က သင့်တစ်ဦးချင်းရလဒ်ကို ကြည့်နိုင်သော်လည်း ကြည့်တိုင်း အကြောင်းပြချက်လိုပြီး သင့် access log တွင် မှတ်တမ်းပေါ်ပါမည်။ Trade Leader နှင့် အခြား manager များသည် အထက်ပါအခန်းကဏ္ဍတစ်ခု မရှိလျှင် မကြည့်နိုင်ပါ။',
      },
      {
        heading: 'Assessment ဖြေဆိုရန်',
        items: [
          'Self-Service → “Big Five Profile” ကိုဖွင့်ပြီး “Start the assessment” ကိုနှိပ်ပါ။',
          'သဘောတူညီချက်ကို ဖတ်၍ လက်ခံပြီး “Agree & begin” ကိုနှိပ်ပါ။',
          'စာကြောင်းတို ၁၂၀ ခုကို ၁ မှ ၅ အဆင့် (Very Inaccurate → Very Accurate) ဖြင့် ဖြေပါ။ အဖြေများ အလိုအလျောက်သိမ်းသဖြင့် ရပ်ပြီး မည်သည့်စက်မှမဆို ပြန်ဆက်နိုင်သည်။',
          'နောက်ဆုံးမေးခွန်းတွင် ရလဒ်ကြည့်ရန် “Submit Big Five Profile” ကိုနှိပ်ပါ။',
        ],
      },
      {
        heading: 'သင့်ရလဒ်နှင့် သင်၏ထိန်းချုပ်ခွင့်',
        items: [
          'ကိုယ်ရည်ကိုယ်သွေးအချက်ငါးခု (Openness, Conscientiousness, Extraversion, Agreeableness, Neuroticism) အလိုက် score များကိုကြည့်ပြီး လိုပါက ကမ္ဘာတစ်ဝန်းရှိသူများ သို့မဟုတ် လုပ်ဖော်ကိုင်ဖက်များနှင့် နှိုင်းယှဉ်နိုင်သည်။',
          'HR မှ မည်သူက ဘာအကြောင်းပြချက်ဖြင့် ကြည့်ခဲ့သည်ကို ကြည့်ရန် “Who has viewed me” ကိုနှိပ်ပါ။',
          'သဘောတူညီချက်ကို ရုပ်သိမ်းပြီး သင့် data ကို အချိန်မရွေး အပြီးအပိုင် ဖျက်နိုင်သည်။',
          'ပုံမှန်အားဖြင့် ၁၂ လလျှင် တစ်ကြိမ် ပြန်ဖြေနိုင်သည်။',
        ],
      },
    ],
  },

  notifications: {
    title: 'အသိပေးချက်များနှင့် နှစ်သက်ရာရွေးချယ်မှုများ',
    summary: 'နောက်ဆုံးအခြေအနေများ သိရှိပြီး အသိပေးစေလိုသည့်နည်းလမ်းကို ရွေးပါ။',
    routeLabel: 'Notification Preferences ဖွင့်ရန်',
    blocks: [
      {
        heading: 'နောက်ဆုံးအခြေအနေ သိရှိရန်',
        items: [
          'နောက်ဆုံးအသိပေးချက်များ (ခွင့်ဆုံးဖြတ်ချက်၊ သတိပေးချက်၊ asset transfer၊ payslip၊ ကြေညာချက် စသည်) ကြည့်ရန် ညာဘက်အပေါ်ရှိ 🔔 ခေါင်းလောင်းကို နှိပ်ပါ။',
          'ခေါင်းလောင်းပေါ် အနီစက်ရှိလျှင် မဖတ်ရသေးသော အသိပေးချက်ရှိပါသည်။',
        ],
      },
      {
        heading: 'မည်သို့ အသိပေးရမည်ကို ရွေးရန်',
        items: [
          '🔔 ခေါင်းလောင်းကိုဖွင့်ပြီး “Notification Preferences” ဖွင့်ရန် settings (gear) ပုံကိုနှိပ်ပါ။',
          'Leave, Attendance, Documents, Payroll, Assets, Celebrations စသည့် category အလိုက် အုပ်စုခွဲထားသော notification type ဇယားကို မြင်ရပါမည်။',
          'Type တစ်ခုစီအတွက် In-App, WhatsApp, Email နှင့် Google Chat channel များကို ဖွင့်/ပိတ်ပါ။',
          'အသုံးပြုရန် “Save Changes” ကိုနှိပ်ပါ။ မသိမ်းဘဲ ပယ်ဖျက်ရန် “Cancel” ကိုသုံးပါ။',
        ],
      },
      {
        heading: 'သိထားသင့်သောအချက်များ',
        items: [
          'In-App notification သည် အမြဲဖွင့်ထားပြီး ပိတ်၍မရပါ။',
          'WhatsApp အတွက် Profile တွင် မှန်ကန်သောဖုန်းနံပါတ်၊ Email အတွက် မှန်ကန်သောအီးမေးလ် ရှိရပါမည်။',
          'သော့ပုံရှိလျှင် administrator က ထို channel ကို သတ်မှတ်ထားသဖြင့် ဤနေရာတွင် ပြောင်း၍မရပါ။',
          '“Disabled by policy” ဆိုသည်မှာ ကုမ္ပဏီက လူတိုင်းအတွက် ထိုအသိပေးချက်ကို ပိတ်ထားခြင်း ဖြစ်သည်။',
          'Birthday Wishes — စာမျက်နှာအောက်တွင် ကုမ္ပဏီတစ်ခုလုံးသို့ ပို့သော မွေးနေ့အီးမေးလ်မှ မပါဝင်လိုကြောင်း ရွေးနိုင်သည်။',
        ],
      },
    ],
  },

  help: {
    title: 'နောက်ထပ် အကူအညီလိုပါသလား',
    summary: 'အခက်အခဲရှိပါက HR အဖွဲ့ကို ဆက်သွယ်ပါ။',
    blocks: [
      {
        heading: 'HR ကို မဆက်သွယ်မီ',
        items: [
          'စာမျက်နှာကို refresh လုပ်ရန် အောက်သို့ ဆွဲချပါ။ မနောက်ဆုံးဖြစ်နေသော အချက်အလက်ပြဿနာကို မကြာခဏ ဖြေရှင်းပေးနိုင်ပါသည်။',
          'သင်လုပ်ဆောင်ရန် စောင့်နေသောအရာရှိမရှိ 🔔 အသိပေးချက်များကို စစ်ပါ။',
          'နောက်ဆုံး version အသုံးပြုနေကြောင်း သေချာစေရန် app ကိုပိတ်ပြီး Home screen မှ ပြန်ဖွင့်ပါ။',
        ],
      },
      {
        text: 'အကူအညီလိုနေသေးပါသလား။ သင့် Staff ID၊ ပြဿနာအကြောင်းအတိုချုံးနှင့်အတူ HR အဖွဲ့ထံ hrm@winner-e.sg သို့ အီးမေးလ်ပို့ပါ (screenshot ပါလျှင် ပိုကောင်းပါသည်)။',
      },
    ],
  },
};
